<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <template>
    <v-layout row wrap>
      <v-form v-model="valid">
        <v-layout row wrap justify-end>
          <v-flex xs4 md2>
            <v-select
              :items="filtros"
              item-text="title"
              label="Filtros"
              item-value="value"
              v-model="filtro"
            >
            </v-select>
          </v-flex>
          <v-flex xs4 md2 shrink>
            <v-select
              :items="frentistas"
              label="Frentista"
              item-value="id_frentista"
              v-model="opcoes.id_frentista"
              clearable
            >
              <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs4 md2 shrink>
            <v-select
              :items="premios"
              label="Premios"
              item-text="nome"
              item-value="id"
              v-model="opcoes.premio"
              clearable
            >
              <template v-slot:item="data">
                <span v-text="`${data.item.nome}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs4 md2>
            <v-text-field
              placeholder="Identificação do cliente"
              class="pr-3"
              v-model="opcoes.id_pessoa"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 md2 shrink>
            <v-text-field
              placeholder="CPF"
              mask="###.###.###-##"
              v-model="opcoes.masked_cpf"
              return-masked-value
              :rules="[rules.cpf]"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 md1>
            <v-select
              :items="options"
              item-text="title"
              item-value="value"
              v-model="selectOpcoes"
            >
            </v-select>
          </v-flex>
          <v-flex xs4 :md3="opcoes.custom" :md2="!opcoes.custom">
            <v-menu
              ref="menuDataInicial"
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-if="opcoes.custom"
                  v-model="opcoes.intervalo_relatorio"
                  label="Dias"
                  multiple
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else-if="opcoes.dia"
                  v-model="opcoes.data_relatorio"
                  label="Dia"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="date = parseDate(opcoes.data_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else
                  v-model="opcoes.mes_relatorio"
                  label="Mes"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="month = parseDate(opcoes.mes_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
              </template>
              <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de vouchers</h1>
            <v-spacer></v-spacer>
            <span class="display-2">Total: {{ total_relatorio_vouchers | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!vouchers_premio || !vouchers_premio.length"
          :loading="loading"
          :items="vouchers_premio"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.codigo"><strong>{{props.item.codigo}}</strong></td>
              <td class="text-xs-left px-3" style="width: auto" v-if="headersVisible.cliente">
                {{`${props.item.cliente.pessoa.nome} ${props.item.cliente.pessoa.sobrenome}` | truncate(30) }}
                <div><strong>{{props.item.cliente.pessoa.id_pessoa}}</strong></div>
              </td>
              <td class="text-xs-left" v-if="headersVisible.data_gerado">{{ props.item.data_gerado.split('-').reverse().join('/') }}</td>
              <td class="text-xs-left" v-if="headersVisible.data_validade">
                <template v-if="props.item.data_inativado">
                  {{ props.item.data_inativado ? props.item.data_inativado.split('-').reverse().join('/') : '' }}
                </template>
              </td>
              <td class="text-xs-left" v-if="headersVisible.premio_nome">
                {{props.item.premio.nome}}
              </td>
              <td class="text-xs-center px-0 hide-print" style="width: 0" v-if="headersVisible.disponivel">
                <v-tooltip v-if="props.item.disponivel" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">done_all</v-icon>
                  </template>
                  <span>Ativo</span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="red">close</v-icon>
                  </template>
                  <span>Usado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left px-3" v-if="headersVisible.codigo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.codigo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Código
              </th>
              <th class="text-xs-left px-3" v-if="headersVisible.cliente">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.cliente = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Cliente
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_gerado">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_gerado = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Gerado em
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_uso">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_uso = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Uso em
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_validade">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_validade = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Validade
              </th>
              <th class="text-xs-left" v-if="headersVisible.premio_nome">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.premio_nome = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Nome do Prêmio
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.disponivel">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.disponivel = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    </template>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      valid: false,
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: null,
      dates: [],
      filtroCPF: '',
      filtro: 'todos',
      vouchers_premio: [],
      filtros: [
        {
          title: 'Todos',
          value: 'todos'
        },
        {
          title: 'Premiados retirados',
          value: 'consumidos'
        }
      ],
      headersVisible: {
        premio_nome: true,
        codigo: true,
        data_gerado: true,
        data_validade: true,
        cliente: true,
        disponivel: true
      },
      today: null,
      selectOpcoes: 'dia',
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        disponivel: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: [],
        id_frentista: null,
        masked_cpf: null,
        id_pessoa: undefined,
        premio: null
      },
      rules: {
        cpf: value => {
          const pattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
          return !value || pattern.test(value) || 'CPF inválido.'
        }
      },
      pagination: {
        page: 1,
        rowsPerPage: 20
      },
      totalItens: 0
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    },
    vouchers () {
      return this.$store.getters.vouchers
    },
    premios () {
      return this.$store.getters.premios
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    total_relatorio_vouchers () {
      return this.$store.getters.total_relatorio_vouchers
    },
    tempOpcoes () {
      let tempOpcoes = {}
      tempOpcoes['run'] = true
      this.opcoes.premio && this.opcoes.premio !== undefined && (tempOpcoes['premio__id'] = this.opcoes.premio)
      this.opcoes.id_frentista && (tempOpcoes['frentista__id_frentista'] = this.opcoes.id_frentista)
      this.opcoes.id_pessoa && this.opcoes.id_pessoa !== '' && (tempOpcoes['cliente__pessoa'] = this.opcoes.id_pessoa)

      // Vai validar o formato do CPF ou perquisar com autocomplementação
      this.valid && this.opcoes.masked_cpf && this.opcoes.masked_cpf !== '' && (tempOpcoes['cliente__pessoa__cpf'] = this.opcoes.masked_cpf.replace(/[^\d]+/g, ''))

      if (this.filtro === 'consumidos') {
        tempOpcoes['disponivel'] = false
        if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
          tempOpcoes['data_inativado__gte'] = this.opcoes.intervalo_relatorio[0]
          tempOpcoes['data_inativado__lte'] = this.opcoes.intervalo_relatorio[1]
        } else if (this.opcoes.dia && this.date) {
          tempOpcoes['data_inativado'] = this.date.split('-').reverse().join('/')
        } else if (this.opcoes.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          tempOpcoes['data_inativado__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          tempOpcoes['data_inativado__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        } else {
          tempOpcoes['run'] = false
        }
      } else {
        if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
          tempOpcoes['data_gerado__gte'] = this.opcoes.intervalo_relatorio[0]
          tempOpcoes['data_gerado__lte'] = this.opcoes.intervalo_relatorio[1]
        } else if (this.opcoes.dia && this.date) {
          tempOpcoes['data_gerado'] = this.date.split('-').reverse().join('/')
        } else if (this.opcoes.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          tempOpcoes['data_gerado__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          tempOpcoes['data_gerado__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        } else {
          tempOpcoes['run'] = false
        }
      }

      return tempOpcoes
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.carregarRelatorio(false)
      },
      deep: true
    },
    posto (val) {
      if (val) {
        this.$store.dispatch('listarFrentistas')
        this.$store.dispatch('pegarPremios')
      }
    },
    filtro (val) {
      this.opcoes.disponivel = false
      if (val === 'consumido') {
        this.opcoes.disponivel = true
      }
    },
    filtroCPF (val) {
      this.$store.dispatch('buscarVouchersCPF', val)
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
      } else if (val === 'custom') {
        this.opcoes.custom = true
      } else if (val === 'mes') {
        this.opcoes.mes = true
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) {
      this.$store.dispatch('listarFrentistas')
      this.$store.dispatch('pegarPremios')
    }
  },
  methods: {
    print () {
      window.print()
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio (zerarPaginacao) {
      if (zerarPaginacao) this.pagination.page = 1
      this.$store.dispatch('relatorioPremios', { filtro: this.tempOpcoes, pagination: this.pagination }).then(value => {
        this.vouchers_premio = value.results
        this.totalItens = value.count
      })
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    }
  }
}
</script>
